// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3v8rE","choiceBoxes":"toolbarselects_choiceBoxes__39csE","simpleField":"toolbarselects_simpleField__27H1L"};